export const seoDefaults = {
  title: 'tearsheetads.com. Compliant ads for advisors, investment managers, and regulated financial institutions.',
  description:
    'tearsheetads.com helps professionals grow, activate, and build their business. Run ads across the web, social networks, and other online platforms, autonomously.',
  imageUrl:'/images/tearsheetads-og.jpg',
};
